import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class RedirectService {

	public possibleRedirectToNewTarget() {
		const pathname = window.location.pathname;
		switch (pathname) {
			case '/onboarding': {
				window.location.pathname = '/administration/user/profile';
				break;
			}
		}
	}

}
